import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import startEN from "./startEN";
import startRU from "./startRU";
import day01RU from "./day01RU";
import day02RU from "./day02RU";
import gameRU from "./gameRU";
import homeEventsRU from "./homeEventsRU";
import storyRU from "./storyRU";
import wifeRU from "./wifeRU";
import otherRU from "./otherRU";
import otherEN from "./otherEN";
import day01EN from "./day01EN";
import day02EN from "./day02EN";
import gameEN from "./gameEN";
import homeEventsEN from "./homeEventsEN";
import storyEN from "./storyEN";
import wifeEN from "./wifeEN";
import day01FR from "./day01FR";
import day02FR from "./day02FR";

i18n
    .use(initReactI18next)
    .init({
        debug: false,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {
                translation: {
                    day01: day01EN,
                    day02: day02EN,
                    game: gameEN,
                    homeEvents: homeEventsEN,
                    other: otherEN,
                    start: startEN,
                    story: storyEN,
                    wife: wifeEN
                }
            },
            fr: {
                translation: {
                    day01: day01FR,
                    day02: day02FR
                }
            },
            ru: {
                translation: {
                    day01: day01RU,
                    day02: day02RU,
                    game: gameRU,
                    homeEvents: homeEventsRU,
                    other: otherRU,
                    start: startRU,
                    story: storyRU,
                    wife: wifeRU
                }
            }
        }
    });

export default i18n;